import { AllActions } from "../actions";
import { StoreState } from "../types";
import * as constants from "../constants";
import { messages } from "../../refdata/UserMessages";

export function results(
  state: StoreState.Results,
  action: AllActions,
): StoreState.Results {
  if (state === undefined) {
    state = {};
  }
  switch (action.type) {
    // case constants.RECEIVE_RESULTS:
    //   return {
    //     data: action.data,
    //     totals: action.totals,
    //   };
    case constants.RECEIVE_RESULTS_FAILURE:
      return {
        ...state,
        error: {
          message: messages.error.fetchResultsFailure,
          detail: String(action.error),
        },
      };
    // TODO: think about right way to deal with this, if/what message to display
    case constants.RECEIVE_COLUMNS_FAILURE:
      return {
        ...state,
        error: {
          message: messages.error.fetchResultsFailure,
          detail: String(action.error),
        },
      };
    case constants.RECEIVE_FIELDS_FAILURE:
      return {
        ...state,
        error: {
          message: messages.error.invalidFieldFailure,
          detail: String(action.error),
        },
      };
  }
  return state;
}
